import { render } from "./deskBox.vue?vue&type=template&id=c630dc98&scoped=true"
import script from "./deskBox.vue?vue&type=script&lang=js"
export * from "./deskBox.vue?vue&type=script&lang=js"

import "./deskBox.vue?vue&type=style&index=0&id=c630dc98&lang=sass&scoped=true"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c630dc98"]])

export default __exports__